module.exports = __webpack_public_path__ + "static/media/gallery5.35a941af.png";